<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center" justify="center">
        <h2>Total cash flow</h2>
        <h4>
          Please only select a end date as the calculation uses the last 30
          days. Values on graph should be vat excl but the stats in the table
          are vat incl.
        </h4>
      </v-col>
    </v-row>
    <v-tabs v-model="tab" align-with-title>
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab key="total"> Total sales </v-tab>
      <v-tab key="new"> New Sales </v-tab>
      <v-tab key="recurring "> Recurring Sales </v-tab>
    </v-tabs>

    <v-tabs-items v-if="salesSummary" v-model="tab">
      <v-tab-item key="total">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <highcharts
              :options="populateTotalReport('totalAmount', 'Total Revenue')"
            ></highcharts>
          </v-col>
        </v-row>
        <v-row
          v-for="product in products"
          :key="product"
          align="center"
          justify="center"
        >
          <v-col cols="12">
            <highcharts
              :options="populateReport(product, 'totalAmount')"
            ></highcharts>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="new">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <highcharts
              :options="populateTotalReport('newAmount', 'Total New Revenue')"
            ></highcharts>
          </v-col>
        </v-row>
        <v-row
          v-for="product in products"
          :key="product"
          align="center"
          justify="center"
        >
          <v-col cols="12">
            <highcharts
              :options="populateReport(product, 'newAmount')"
            ></highcharts>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="recurring">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <highcharts
              :options="
                populateTotalReport(
                  'recurringAmount',
                  'Total Recurring Revenue'
                )
              "
            ></highcharts>
          </v-col>
        </v-row>
        <v-row
          v-for="product in products"
          :key="product"
          align="center"
          justify="center"
        >
          <v-col cols="12">
            <highcharts
              :options="populateReport(product, 'recurringAmount')"
            ></highcharts>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { SALES_SUMMARY_QUERY } from "@/constants/graphql/billing/billing";
export default {
  name: "SalesMetrics",
  props: {
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      tab: "total",
      salesSummary: null,
      products: [],
    };
  },
  methods: {
    populateTotalReport(key, title) {
      let dates = this.salesSummary.map((val) => {
        return this.$moment(val.date).format("YYYY-MM-DD");
      });
      let start = this.$moment(this.endDate).startOf("month");
      let current_data_series = this.salesSummary.filter((val) => {
        return this.$moment(val.date) >= start;
      });

      let previous_data_series = this.salesSummary.filter((val) => {
        return this.$moment(val.date) < start;
      });

      current_data_series = current_data_series.map((val) => {
        let amount = val[key] / 1.15;

        return [this.$moment(val.date).format("YYYY-MM-DD"), amount];
      });

      previous_data_series = previous_data_series.map((val) => {
        let amount = val[key] / 1.15;
        return [
          this.$moment(val.date).add(1, "M").format("YYYY-MM-DD"),
          amount,
        ];
      });

      return {
        chart: {
          type: "line",
        },
        title: {
          text: title.toUpperCase(),
        },
        tooltip: {
          split: true,
          distance: 30,
          padding: 5,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: dates,
          crosshair: {
            enabled: true,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "ZAR",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        plotOptions: {},

        series: [
          {
            name: "Current month",
            data: current_data_series,
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function () {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return (
                  "Sales on day: R<b>" +
                  y.toFixed(2) +
                  "</b></b><br/> Sales to date: R<b>" +
                  total.toFixed(2) +
                  "</b>"
                );
              },
            },
          },
          {
            name: "Previous month",
            data: previous_data_series,
            color: "purple",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function () {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return (
                  "Sales on day: R<b>" +
                  y.toFixed(2) +
                  "</b></b><br/> Sales to date: R<b>" +
                  total.toFixed(2) +
                  "</b>"
                );
              },
            },
          },
        ],
      };
    },
    populateReport(productCode, key) {
      let dates = this.salesSummary.map((val) => {
        return this.$moment(val.date).format("YYYY-MM-DD");
      });
      let start = this.$moment(this.endDate).startOf("month");
      let current_data_series = this.salesSummary.filter((val) => {
        return this.$moment(val.date) >= start;
      });

      let previous_data_series = this.salesSummary.filter((val) => {
        return this.$moment(val.date) < start;
      });

      current_data_series = current_data_series.map((val) => {
        let revItem = val.revenueitemSet.filter((item) => {
          return item.product.code == productCode;
        });
        let amount = 0;

        if (revItem.length > 0) {
          amount = revItem[0][key] / 1.15;
        }

        return [this.$moment(val.date).format("YYYY-MM-DD"), amount];
      });

      previous_data_series = previous_data_series.map((val) => {
        let revItem = val.revenueitemSet.filter((item) => {
          return item.product.code == productCode;
        });

        let amount = 0;

        if (revItem.length > 0) {
          amount = revItem[0][key] / 1.15;
        }

        return [
          this.$moment(val.date).add(1, "M").format("YYYY-MM-DD"),
          amount,
        ];
      });

      return {
        chart: {
          type: "line",
        },
        title: {
          text: productCode.toUpperCase(),
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          split: true,
          distance: 30,
          padding: 5,
        },
        xAxis: {
          categories: dates,
          crosshair: {
            enabled: true,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "ZAR",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        plotOptions: {},

        series: [
          {
            name: "Current month",
            data: current_data_series,
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function () {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return (
                  "Sales on day: R<b>" +
                  y.toFixed(2) +
                  "</b></b><br/> Sales to date: R<b>" +
                  total.toFixed(2) +
                  "</b>"
                );
              },
            },
          },
          {
            name: "Previous month",
            data: previous_data_series,
            color: "purple",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function () {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return (
                  "Sales on day: R<b>" +
                  y.toFixed(2) +
                  "</b></b><br/> Sales to date: R<b>" +
                  total.toFixed(2) +
                  "</b>"
                );
              },
            },
          },
        ],
      };
    },
  },
  apollo: {
    salesSummary: {
      query: SALES_SUMMARY_QUERY,
      variables() {
        return {
          endDate: this.endDate,
        };
      },
      skip() {
        return !this.endDate;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
          let productList = [];
          response.data.salesSummary.forEach((val) => {
            val.revenueitemSet.forEach((item) => {
              productList.push(item.product.code);
            });
          });
          this.products = [...new Set(productList.sort())];
        }
        if (
          response.error &&
          response.error.gqlError?.message == "Permission Denied."
        ) {
          this.$router.push("/no-access");
        }
      },
    },
  },
};
</script>

